import { CloudPremisePlugin } from "@cloudpremise/portal_core";
import { S3 } from 'aws-sdk';
export class FileManager extends CloudPremisePlugin {
    s3Client: S3;
    getAwsClient?(): any;
};